import { ReactNode } from 'react';
import { InquiryStatusFilter } from '@texas/api/endpoints/inquiryApi';
import { EntityLifecycleTabs } from '@texas/components/shared/entityDirectory/EntityLifecycleTabs';
import { useTranslation } from 'react-i18next';

export type InquiryLifecycle = InquiryStatusFilter | 'archived' | 'all';

export interface InquiryLifecycleCounts {
  open: number;
  sent: number;
  pricesReceived: number;
  accepted: number;
  archived: number;
}

interface Props {
  children: ReactNode;
  filters: ReactNode;
  active: InquiryLifecycle;
  counts: InquiryLifecycleCounts;
  onChange: (value: InquiryLifecycle) => void;
}

const items = [
  { label: 'filter.all', value: 'all' },
  { label: 'general.open', value: 'open' },
  { label: 'inquiry.sent', value: 'sent' },
  { label: 'inquiry.pricesReceived', value: 'prices-received' },
  { label: 'general.accepted', value: 'accepted' },
  { label: 'inquiry.archived', value: 'archived' },
] as const;

export function InquiryLifecycleTabs({
  active,
  counts,
  onChange,
  children,
  filters,
}: Props) {
  const { t } = useTranslation();
  const lifecycleCounts = {
    ...counts,
    'prices-received': counts.pricesReceived,
    all:
      counts.open +
      counts.sent +
      counts.pricesReceived +
      counts.accepted +
      counts.archived,
  };
  const lifecycleItems = items.map((item) => ({
    ...item,
    count: lifecycleCounts[item.value],
    label: t(item.label),
  }));

  return (
    <EntityLifecycleTabs
      active={active}
      filters={filters}
      items={lifecycleItems}
      label={t('inquiry.lifecycle')}
      onChange={onChange}
    >
      {children}
    </EntityLifecycleTabs>
  );
}
